import color from "../../constants/color";

const styles ={

  
  title:{
    fontSize:"18px",
    fontWeight:"600",
    display:"flex",
    flexDirection:"row",
    alignItems:"center",
    justifyContent:"space-between",
    "& .css-1dzapu9-MuiTypography-root-MuiDialogTitle-root":{
      marginBottom:2
    }
  },
  modalPaper:{
    "& .css-1t1j96h-MuiPaper-root-MuiDialog-paper":{
      borderRadius:"20px",
      width:"100%"

    },
  },
  closeIcon:{
    position: "absolute",
    right: 15,
    color: color.card,
    backgroundColor:color.text,
    width:"27px",
    height:"27px",
    "&:hover": {
      backgroundColor: color.text,
    },
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    
  },
  deletebutton:{
    backgroundColor:color.red,
    color: color.card,
    textTransform:"none",
    borderRadius:"20px",
    px:3,
    "&:hover": {
      backgroundColor: `${color.red} !important`, // Override hover color
    },

    "& .css-knqc4i-MuiDialogActions-root ":{
      justifyContent:"flex-start",
      
    },

  },
  cancelbutton:{
    backgroundColor:color.lightText,
    color: color.card,
    textTransform:"none",
    borderRadius:"20px",
    px:3,
    "&:hover": {
      backgroundColor: `${color.lightText} !important`, // Override hover color
    },

    "& .css-knqc4i-MuiDialogActions-root ":{
      justifyContent:"flex-start",
      
    },

  },
  button:{
    backgroundColor:color.primary,
    color: color.card,
    textTransform:"none",
    borderRadius:"20px",
    // marginLeft:"12px",
    // mt:1,
    px:3,
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator" :{
      position: "unset", 
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px", 
      marginLeft: "-8px", 
    },


    "&:hover": {
      backgroundColor: `${color.primary} !important`, // Override hover color
    },

    "& .css-knqc4i-MuiDialogActions-root ":{
      justifyContent:"flex-start",
      
    },
    // position:"absolute",
    // left:18,
    // mb:"20px"
  },
  btnGrid: {
    justifyContent: "space-between",
  },
  buttonDisable:{
    backgroundColor:color.lightGray,
    borderRadius:"20px",
    px:3,
    textTransform:"none", 
  },
  actionBtn:{
    justifyContent:"space-between",
    mx:2,
    pb:"20px",
  },
  actionBtn2:{
    justifyContent:"flex-start",
    mx:2,
    pb:"20px",
  },
  approve:{
    color: color.primary,
    // border: "1px solid #28AA4A",
    backgroundColor: "#28AA4A33",
    borderRadius: "20px",
    px: 3,
    py: 0.5,
    textTransform: "none",
    mr: 1,
    fontSize:"14px",
    fontWeight:"400"
  },
  reject:{
    color: "red",
    // border: "1px solid red",
    backgroundColor: "#E9303033",
    borderRadius: "20px",
    fontSize:"14px",
    px: 3,
    py: 0.5,
    textTransform: "none",
    fontWeight:"400"
  }
};
export default styles;